module.exports = __webpack_public_path__ + "static/media/S (203).85d92d84.jpg";